<template>
  <div
    class="col-span-6 sm:col-span-3 xl:col-span-2 flex flex-col justify-end items-center"
    v-if="loading"
  >
    <LoadingIcon icon="three-dots" class="w-8 h-8" />
  </div>
  <div v-if="!loading">
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <AwardIcon />
      <h2 class="text-lg font-medium mr-auto">{{ $t('advertisement.detail') }}</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <router-link
          :to="{ name: 'superadmin-tools-advertisement-convert' }"
          tag="a"
          class="btn btn-primary shadow-md flex items-center"
          v-if="!editor"
        >
          <PlusIcon class="w-4 h-4 mr-2" /> {{ $t('advertisement.convert') }}
        </router-link>
        <router-link
          :to="{ name: 'superadmin-tools-advertisement' }"
          tag="a"
          class="btn shadow-md flex items-center"
        >
          <ArrowLeftCircleIcon class="w-4 h-4 mr-2" /> {{ $t('common.back') }}
        </router-link>
      </div>
    </div>
    <div class="intro-y box px-5 pt-5 mt-5 pb-5 items-center">
      <div
        class="flex flex-col lg:flex-row border-b border-gray-200 dark:border-dark-5 pb-5 -mx-5"
      >
        <div class="flex flex-1 px-5 items-center justify-center">
          <img
            :src="advertisement.branch.imageWide"
            class="center"
            v-if="advertisement.branch.imageWide"
            style="max-width: 1264px; max-height: 300px"
          />
        </div>
      </div>
    </div>
    <div class="intro-y box px-5 pt-5 mt-5">
      <div
        class="flex flex-col lg:flex-row border-b border-gray-200 dark:border-dark-5 pb-5 -mx-5"
      >
        <div class="flex flex-1 px-5 items-center justify-center lg:justify-start">
          <div
            class="w-20 h-20 sm:w-24 sm:h-24 flex-none lg:w-32 lg:h-32 image-fit relative"
          >
            <img
              alt="Service image"
              class="rounded-full"
              :src="advertisement.branch.image"
              v-if="advertisement.branch.image"
            />
          </div>
          <div class="ml-5">
            <div class="w-24 sm:w-40 truncate sm:whitespace-normal font-medium text-lg">
              {{ advertisement.branch.name }}
            </div>
            <div class="text-gray-600">
              {{ advertisement.branch.description.sk_SK }}
            </div>
          </div>
        </div>
        <div
          class="mt-6 lg:mt-0 flex-1 dark:text-gray-300 px-5 border-l border-r border-gray-200 dark:border-dark-5 border-t lg:border-t-0 pt-5 lg:pt-0"
        >
          <div class="font-medium text-center lg:text-left lg:mt-3">
            {{ $t('common.detail') }}
          </div>
          <div class="flex flex-col justify-center items-center lg:items-start mt-4">
            <div class="truncate sm:whitespace-normal flex items-center">
              <WatchIcon class="w-4 h-4 mr-2" />
              <ul>
                <li v-if="advertisement.branch.openHours.openMonday">
                  {{ $t('common.days.monday') }}
                  {{
                    advertisement.branch.openHours.monday === null
                      ? 'nonstop'
                      : advertisement.branch.openHours.monday
                  }}
                </li>
                <li v-if="advertisement.branch.openHours.openTuesday">
                  {{ $t('common.days.tuesday') }}
                  {{
                    advertisement.branch.openHours.tuesday === null
                      ? 'nonstop'
                      : advertisement.branch.openHours.tuesday
                  }}
                </li>
                <li v-if="advertisement.branch.openHours.openWednesday">
                  {{ $t('common.days.wednesday') }}
                  {{
                    advertisement.branch.openHours.wednesday === null
                      ? 'nonstop'
                      : advertisement.branch.openHours.wednesday
                  }}
                </li>
                <li v-if="advertisement.branch.openHours.openThursday">
                  {{ $t('common.days.thursday') }}
                  {{
                    advertisement.branch.openHours.thursday === null
                      ? 'nonstop'
                      : advertisement.branch.openHours.thursday
                  }}
                </li>
                <li v-if="advertisement.branch.openHours.openFriday">
                  {{ $t('common.days.friday') }}
                  {{
                    advertisement.branch.openHours.friday === null
                      ? 'nonstop'
                      : advertisement.branch.openHours.friday
                  }}
                </li>
                <li v-if="advertisement.branch.openHours.openSaturday">
                  {{ $t('common.days.saturday') }}
                  {{
                    advertisement.branch.openHours.saturday === null
                      ? 'nonstop'
                      : advertisement.branch.openHours.saturday
                  }}
                </li>
                <li v-if="advertisement.branch.openHours.openSunday">
                  {{ $t('common.days.sunday') }}
                  {{
                    advertisement.branch.openHours.sunday === null
                      ? 'nonstop'
                      : advertisement.branch.openHours.sunday
                  }}
                </li>
              </ul>
            </div>
            <div class="truncate sm:whitespace-normal flex items-center mt-3">
              <CheckCircleIcon class="w-4 h-4 mr-2" v-if="advertisement.branch.active" />
              <CircleIcon class="w-4 h-4 mr-2" v-if="!advertisement.branch.active" />
              {{ $t('common.activeShe') }}
              <div
                v-if="
                  advertisement.branch.active &&
                  advertisement.visibleFrom !== null &&
                  advertisement.visibleTo === null
                "
              >
                &nbsp;- {{ formatDate(advertisement.visibleFrom) }} &lt;
              </div>
              <div
                v-if="
                  advertisement.branch.active &&
                  advertisement.visibleFrom === null &&
                  advertisement.visibleTo !== null
                "
              >
                &nbsp;- {{ formatDate(advertisement.visibleTo) }} &gt;
              </div>
              <div
                v-if="
                  advertisement.branch.active &&
                  advertisement.visibleFrom !== null &&
                  advertisement.visibleTo !== null
                "
              >
                &nbsp;-
                {{
                  formatDate(advertisement.visibleFrom) +
                  ' - ' +
                  formatDate(advertisement.visibleTo)
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- BEGIN: Failed Notification Content -->
  <div id="failed-load-notification-content" class="toastify-content hidden flex">
    <XCircleIcon class="text-theme-6" />
    <div class="ml-4 mr-4">
      <div class="font-medium">{{ $t('advertisement.branch.notLoaded') }}!</div>
      <!-- <div class="text-gray-600 mt-1">Please check the fileld form.</div> -->
    </div>
  </div>
  <!-- END: Failed Notification Content -->
</template>

<script>
import { defineComponent, ref } from 'vue'
import advertisementApi from '@/services/advertisement/advertisement.api'
import Toastify from 'toastify-js'

export default defineComponent({
  components: {},
  methods: {
    formatDate(date) {
      const d = new Date(date)
      return (
        d.toISOString().replace(/^(\d+)-(\d+)-(\d+).*$/, '$3.$2.$1') +
        ' ' +
        d.toLocaleTimeString().replace(/^(\d+):(\d+):\d+$/, '$1:$2')
      )
    }
  },
  computed: {
    console: () => console
  },
  data() {
    return {
      editor: false,
      advertisement: {
        branch: {}
      }
    }
  },
  mounted() {
    this.editor = localStorage.getItem('auth_editor')
    advertisementApi.getDetail(this.$route.params.uuid).then(
      (response) => {
        this.advertisement = response.data
        this.loading = false
      },
      (error) => {
        console.log(error)
        Toastify({
          node: cash('#failed-notification-content').clone().removeClass('hidden')[0],
          duration: 10000,
          newWindow: true,
          close: true,
          gravity: 'top',
          position: 'right',
          stopOnFocus: true
        }).showToast()
        this.$router.push({ name: 'superadmin-tools-advertisement' })
      }
    )
  },
  setup() {
    const loading = ref(true)

    return {
      loading
    }
  }
})
</script>
